import React, { useState, useMemo } from 'react';
import BaseInput from '../BaseInput/BaseInput';
import BaseInputIcon from '../BaseInput/BaseInputIcon';
import InputControl from '../InputControl/InputControl';
import { BaseTextInputProps } from '../shared-types';
import { noop } from '../utils';

export type Props = BaseTextInputProps;

const PasswordInput: React.FC<Props> = (props: Props) => {
  const [isHidden, setIsHidden] = useState(true);
  const adornment = useMemo(
    () => (
      <BaseInputIcon
        icon={isHidden ? 'eyeOpened' : 'eyeClosed'}
        onClick={() => setIsHidden(!isHidden)}
      />
    ),
    [isHidden]
  );
  const {
    label,
    error,
    onChange,
    hint,
    required,
    eventId,
    onHintToggle = noop,
    ...rest
  } = props;

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <InputControl
      id={`PasswordInput-${label}`}
      label={label}
      errorMessage={error}
      hint={hint}
      required={required}
      eventId={eventId}
      onHintToggle={onHintToggle}
    >
      <BaseInput
        {...rest}
        label={label}
        onChange={handleChange}
        error={!!error}
        componentName="PasswordInput"
        adornmentRight={adornment}
        type={isHidden ? 'password' : 'text'}
      />
    </InputControl>
  );
};

export default PasswordInput;
